import { FC } from 'react';

import { LEAD_TEST_IDS } from '../constants';
import { LeadFieldName } from '../model';

type Props = { value?: string };

export const ProductTypeField: FC<Props> = ({ value = '' }) => {
    return (
        <input
            type="hidden"
            value={value}
            name={'productType' as LeadFieldName}
            data-test={LEAD_TEST_IDS.FIELD_PRODUCT_TYPE}
        />
    );
};
